import type {MediaHandler} from 'matrix-js-sdk/lib/webrtc/mediaHandler';
import logger from '../logger';

interface SerialisedMediaRequests {
    getMediaStreamPromise?: Promise<MediaStream>;
}

const ERROR_NAME = /\b([A-Z][A-Za-z]*Error)\b/;

export const mediaErrorName = (error: unknown): string | undefined => {
    if (error instanceof Error && error.name !== 'Error') return error.name;
    const text = error instanceof Error ? error.message : String(error);
    return ERROR_NAME.exec(text)?.[1];
};

export const releaseRejectedMediaRequests = (handler: MediaHandler): void => {
    const chain = handler as unknown as SerialisedMediaRequests;
    const request = handler.getUserMediaStream.bind(handler);
    handler.getUserMediaStream = (audio, video, reusable) => {
        const result = request(audio, video, reusable);
        const queued = chain.getMediaStreamPromise;
        queued?.catch((error: unknown) => {
            if (chain.getMediaStreamPromise !== queued) return;
            chain.getMediaStreamPromise = undefined;
            logger.warn('Media request failed; the next one starts fresh', {
                source: 'matrix_call',
                event: 'media_handler_reset',
                audio,
                video,
                errorName: mediaErrorName(error),
            });
        });
        return result;
    };
};
